import { none } from "ramda"

const styles = theme => ({
  dialogPaper: {
    width: "100%",
    maxWidth: 800,
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"],
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0,
  },
  dialogActionsAction: {
    margin: 0,
  },
  backgroundLight: {
    backgroundColor: "#f6f6fe",
    height: "auto",
    paddingTop: "5px",
    margin: theme.spacing(2),
  },
  boxAlign: {
    marginLeft: "10px",
    width: " 50px",
    display: "flex",
  },
  headlineWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  dialogTitle: {
    // padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.primary.dark,
    color: "white",
  },
  headline: {
    opacity: 1,
    fontSize: "1.2em",
    display: "inline",
    fontWeight: "600",
  },
  socialHeadline: {
    opacity: 0.6,
    fontSize: "1em",
    display: "inline",
  },
  logoWrapper: {
    width: "100%",
    paddingTop: "100%",
    position: "relative",
    "&:hover $addImageOverlay": {
      opacity: 1,
    },
  },
  addPhotoIcon: {
    color: "#fff",
    width: "1.6em",
    height: "1.6em",
  },
  logoImage: {
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.secondary.main,
  },
  logo: {
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.secondary.main,
  },
  logoUploadOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.active,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "wait",
  },
  addImageOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.disabled,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "pointer",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  logoPaper: {
    position: "relative",
  },
  logoLabel: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  logoInput: {
    opacity: 0,
    outline: "none",
  },
  saveAndCloseButton: {
    marginLeft: theme.spacing(1),
  },
  inputWithAddButton: {
    display: "flex",
    padding: `${theme.spacing(1)}px 0`,
    alignItems: "center",
  },
  newInputWrapper: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
  },
  manager: {
    display: "flex",

    // paddingBottom: 12,
    "&:not(:first-child)": {
      paddingTop: 12,
    },
    "&:last-of-type": {
      borderBottom: "none",
    },
    width: "100%",
  },
  managerContent: {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  managerAvatarWrapper: {
    position: "relative",
    "&:hover $removeManagerIcon": {
      transform: "translate(-50%,-50%) scale(1)",
    },
  },
  managerAvatar: {
    alignSelf: "center",
  },
  removeManagerIcon: {
    cursor: "pointer",
    position: "absolute",
    zIndex: "1",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%) scale(0)",
    color: theme.palette.grey[800],
    width: "calc(100% + 9px)",
    height: "calc(100% + 9px)",
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  chip: {
    backgroundColor: theme.palette.primary.main,
    margin: theme.spacing(1 / 4),
    color: "#000000",
    marginTop: 12,
    borderRadius: "unset",
  },
  chipDeleteIcon: {
    color: "#000000",
  },
  cancelButton: {
    color: theme.palette.primary.dark,
  },
  saveButton: {
    backgroundColor: theme.palette.primary.dark,
    color: "#fff",
  },
  collapseStyles: {
    boxShadow: "none",
    position: "none",
    borderBottom: "0.5px solid #9c9c9c !important",
  },
  designationText: {
    fontSize: "0.75rem",
  },
  actionText: {
    fontSize: "0.75rem",
    color: "#e6686d",
    paddingTop: "0",
  },
  activeCompanyText: {
    color: theme.palette.primary.dark,
    fontSize: "0.75rem",
    marginLeft: "10px",
    fontWeight: 600,
  },
  marginTop4: {
    marginTop: theme.spacing(4),
  },
  switchWrapper: {
    display: "flex",
    alignItems: "center",
  },
  socialSwitchWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  twitterIcon: {
    color: "#1DA1F2",
  },
})

export default styles
